"use strict";

module.exports = {
  'name': 're',
  'category': 'Complex',
  'syntax': ['re(x)'],
  'description': 'Get the real part of a complex number.',
  'examples': ['re(2 + 3i)', 'im(2 + 3i)', 're(-5.2i)', 're(2.4)'],
  'seealso': ['im', 'conj', 'abs', 'arg']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/complex/re.js
// module id = 874
// module chunks = 0